import React from 'react';
import { Heading, Logo, Paragraph } from '@landr/maestro';
import { useAppConfig } from '@landr/mfe';
import { Trans } from '@lingui/macro';
import DescriptiveSection from '../DescriptiveSection/DescriptiveSection';
import OneCreditOneSample from '../OneCreditOneSample/OneCreditOneSample';
import { headingStyled } from '../DescriptivePaidUpsell/DescriptivePaidUpsell';

const DescriptiveFreeUpsell = () => {
    const { name } = useAppConfig();

    return (
        <DescriptiveSection>
            {name === 'LANDR' && (
                <Logo variant="brand" color="text.inverted" mb="2xl" />
            )}
            <Heading as="h2" className={headingStyled}>
                <Trans>Unlock 3 million exclusive and curated samples</Trans>
            </Heading>
            <OneCreditOneSample />
            <Paragraph color="text.inverted" mt="2xl">
                <Trans>
                    Don’t miss out on royalty-free sounds from today’s best
                    artists, producers and labels.
                </Trans>
            </Paragraph>
        </DescriptiveSection>
    );
};

export default DescriptiveFreeUpsell;
